import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box, Divider} from 'views/components';
import {RefreshWidget} from 'views/module';

import ClientName from './client_name/ClientName';
import ClientStatus from './client_status/ClientStatus';

const ClientTitle = (props) => {
  const clientData = props.clientData;
  const clientBackend = props.clientBackend;
  const refresh = props.refresh;
  const setRefresh = props.setRefresh;

  return (
    <>
      <Stack
        direction='row'
        justifyContent={'space-between'}
        alignItems="center"
        sx={{
          p: 1,
          px: {md: 2, xs: 1},
        }}
      >
        <Box>
          <Stack
            direction='row'
            spacing={1}
          >
            <ClientStatus
              clientData={clientData}
              clientBackend={clientBackend}
            />
            <ClientName
              clientData={clientData}
              clientBackend={clientBackend}
            />
          </Stack>
        </Box>
        <Box sx={{minWidth: '37%'}}>
          <RefreshWidget numRefresh={refresh} setNumRefresh={setRefresh} justifyContent='end'/>
        </Box>
      </Stack>
      <Divider/>
    </>
  );
};
ClientTitle.propTypes = {
  clientRn: PropTypes.string.isRequired,
  clientData: PropTypes.object.isRequired,
  clientBackend: PropTypes.object.isRequired,
  refresh: PropTypes.number.isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default React.memo(ClientTitle);
